
import { add, Dinero } from "dinero.js";
import { Receipt } from "react-bootstrap-icons";

import { showMoney, cents } from "../Data/Money";
import { OrderFeeCalculation } from "../Data/ApiTypes";

interface MonthlyPriceBreakdownProps {
    price: Dinero<number>;
    fees: OrderFeeCalculation[];
    showTotalLabel?: string;
    showProratedHint?: boolean;
}

export function MonthlyPriceBreakdown({ price, fees, showTotalLabel = "Total Price", showProratedHint = false }: MonthlyPriceBreakdownProps) {
    return (
        <div className="bg-white rounded-3 shadow overflow-hidden" style={{ gridColumn: "1 / 4" }}>
        <div className="px-3 py-2 text-white" 
              style={{ background: 'linear-gradient(135deg, #FC5EB4 0%, #b61a70 100%)' }}>
          <Receipt className="me-2 icon-shift-up" />
          Price Breakdown
        </div>
        
        {fees.length > 0 ? (
          <>
            <div className="px-3 py-2 d-flex justify-content-between border-bottom">
              <span>Base Price{" "}
              {showProratedHint && (
              <small className="text-muted" style={{ fontSize: ".8rem" }}>
                (Prorated)
              </small>
              )}
            </span>
              <span className="fw-medium">{showMoney(price)}</span>
            </div>
            
            {fees.map((fee, index) => (
              <div key={index} className="px-3 py-2 d-flex justify-content-between border-bottom">
                <span style={{fontSize:".9rem"}} className='text-muted'>{fee.name}</span>
                <span style={{fontSize:".9rem"}} className="fw-medium text-muted">{showMoney(cents(fee.amount))}</span>
              </div>
            ))}
            
            <div className="px-3 py-3 fs-5 d-flex justify-content-between text-white fw-bold" 
                  style={{ background: 'linear-gradient(135deg,rgb(56, 56, 56) 0%,rgb(77, 77, 77) 100%)' }}>
              <span><i className="fas fa-dollar-sign me-2"></i>{showTotalLabel}</span>
              <span >{showMoney(fees.reduce((total, fee) => add(total, cents(fee.amount)), price))}</span>
            </div>
          </>
        ) : (
          <div
            className="px-3 py-3 d-flex justify-content-between text-white fw-bold"
            style={{
              background:
                "linear-gradient(135deg,rgb(56, 56, 56) 0%,rgb(77, 77, 77) 100%)",
            }}
          >
          <span>
            {showTotalLabel}{" "}
            {showProratedHint && (
              <small
                style={{
                  fontSize: ".8rem",
                  fontWeight: "normal",
                  opacity: 0.7,
                  color: "white",
                }}
              >
                (Prorated)
              </small>
            )}
          </span>
            <span>{showMoney(price)}</span>
          </div>
        )}
      </div>
    );
} 